import React from 'react';
import { API, graphqlOperation } from 'aws-amplify';
import { onCreateNotification } from '../../graphql/subscriptions';
import GraphqlApi from '../../api-graphql';
import { useTranslation } from 'react-i18next';

const useSubscribeToExportHistory = ({ group, subgroups, type }) => {
  const [state, setState] = React.useState(null);
  const { t } = useTranslation();

  async function subscribeToExportHistory () {
    return API.graphql(
      graphqlOperation(onCreateNotification, { group, subgroups: [subgroups] })).subscribe({
      next: (data) => {
        if (data.value.data.onCreateNotification.type === 'exportData') {
          if (data.value.data.onCreateNotification.code === 'ExportIsReady') {
            const notification = JSON.parse(data.value.data.onCreateNotification.data);
            setState(prev => prev.map((item) => {
              if (item.createdAt === notification.item.Attributes.createdAt) {
                item.status = notification.item.Attributes.status;
                item.downloadLink = notification.item.Attributes.downloadLink;
              }
              return item;
            }));
          }
          if (data.value.data.onCreateNotification.code === 'ExportIsProcessing') {
            const notification = JSON.parse(data.value.data.onCreateNotification.data);
            setState(prev => {
              prev.unshift({
                createdAt: notification.item.createdAt,
                filters: parseDeepFilters(notification.item.filters),
                status: notification.item.status,
                downloadLink: 'generating'
              });
              return [...prev];
            });
          }
          if (data.value.data.onCreateNotification.code === 'ExportIsError') {
            const notification = JSON.parse(data.value.data.onCreateNotification.data);
            setState(prev => {
              prev.unshift({
                createdAt: notification.item.createdAt,
                filters: parseDeepFilters(notification.item.filters),
                status: notification.item.status
              });
              return [...prev];
            });
          }
        }
      },
      error: error => {
        console.warn(error);
        getInitialData();
      }
    });
  }

  const parseDeepFilters = (filters) => {
    const parsedFilters = typeof filters === 'string' ? JSON.parse(filters) : filters;
    delete parsedFilters.type;
    delete parsedFilters.subgroup;
    const arr = Object.entries(parsedFilters).map(([key, value]) => {
      if (key === 'dateRange') {
        return [key, Object.values(value).join('-')];
      }
      if (typeof value === 'object') {
        return [key, Object.values(value).map((v) => t(`exportData:${v}`)).join(', ')];
      }
      if (key === 'exportType') {
        return [key, value ? t('exportData:extended') : t('exportData:basic')];
      }
      if (typeof value === 'boolean') {
        const name = value ? 'true' : 'false';
        return [key, name];
      }
      return [key, value];
    });

    return arr;
  };

  const getInitialData = async () => {
    const documentType = type || 'document';
    const filter = { type: { eq: documentType } };
    const id = `${group}#${documentType}`;
    await GraphqlApi.listExportHistories(id, filter).then((data) => {
      const { items } = data.data.listExportHistories;
      const dataParsed = items.map((item) => {
        const filter = parseDeepFilters(item.filters);
        return {
          name: item.id,
          createdAt: item.createdAt,
          filters: filter,
          status: item.status,
          downloadLink: item.downloadLink
        };
      });
      setState(dataParsed);
    }
    ).catch((error) => {
      console.log('error', error);
    });
  };

  React.useEffect(() => {
    const subscription = subscribeToExportHistory();
    getInitialData();

    return () => {
      try {
        subscription.unsubscribe();
      } catch (err) {
        console.log('error unsubscribe export', err);
      }
    };
  }, []);
  return state;
};

export default useSubscribeToExportHistory;
